import React, { useState } from 'react';
import API from '../services/api';
import styles from "../styles/AdminLogin.module.css"
import { useNavigate } from 'react-router-dom';

export default function AdminLogin() {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const navigate = useNavigate();

    const handleLogin = async () => {

        try {

            setError('');

            const res = await API.post('/auth/login', {
                email,
                password
            });

            localStorage.setItem('token', res.data.token);

            navigate('/admin');

        } catch (err) {

            setError(
                err.response?.data?.message ||
                'Login failed'
            );
        }
    };

    return (
        <div className={styles.page}>

            <div className={styles.card}>

                <h2 className={styles.title}>
                    Admin Login
                </h2>

                <p className={styles.subtitle}>
                    Restaurant management access
                </p>

                <div className={styles.formGroup}>
                    <input
                        className={styles.input}
                        placeholder="Admin Email"
                        value={email}
                        onChange={(e) =>
                            setEmail(e.target.value)
                        }
                    />
                </div>

                <div className={styles.formGroup}>
                    <input
                        className={styles.input}
                        placeholder="Password"
                        type="password"
                        value={password}
                        onChange={(e) =>
                            setPassword(e.target.value)
                        }
                    />
                </div>

                <button
                    className={styles.button}
                    onClick={handleLogin}
                >
                    Login
                </button>

                {
                    error && (
                        <p className={styles.error}>
                            {error}
                        </p>
                    )
                }

            </div>

        </div>
    );
}